import { Home as HomeIcon, TrainFront, Plane, BookOpen, HeartPulse, ShoppingBag } from 'lucide-react';

export const SECTORS = [
  {
    slug: 'housing-communities', img: 'housing', label: 'Housing & Communities', Icon: HomeIcon,
    lede: 'Homes and neighbourhoods where neurodivergent families can settle, connect and thrive.',
    offers: ['Neuro-inclusive design reviews for new developments', 'Family regulation and community spaces', 'Resident journey and wayfinding guidance'],
  },
  {
    slug: 'transport-mobility', img: 'transport', label: 'Transport & Mobility', Icon: TrainFront,
    lede: 'Calmer, more predictable journeys across stations, routes and interchanges.',
    offers: ['Station and interchange access reviews', 'Quiet routes and visual journey flows', 'Staff awareness and family assistance models'],
  },
  {
    slug: 'aviation', img: 'aviation', label: 'Aviation', Icon: Plane,
    lede: 'Airport journeys families can plan for — from kerb to gate.',
    offers: ['Terminal journey and sensory-load mapping', 'Family regulation spaces and lounges', 'Pre-travel information and Digital Access Passport support'],
  },
  {
    slug: 'education', img: 'education', label: 'Education', Icon: BookOpen,
    lede: 'Learning environments that work with different minds, not against them.',
    offers: ['Sensory-aware classroom and campus guidance', 'Transition support between settings', 'N3URO Academy pathways and partnerships'],
  },
  {
    slug: 'health-hospitality', img: 'health', label: 'Health & Hospitality', Icon: HeartPulse,
    lede: 'Welcoming, predictable visits to clinics, hotels and venues.',
    offers: ['Arrival, waiting and check-in reviews', 'Advance information and visual stories', 'Team guidance for neuro-inclusive welcome'],
  },
  {
    slug: 'retail-leisure', img: 'retail', label: 'Retail & Leisure', Icon: ShoppingBag,
    lede: 'Shopping and days out every member of the family can enjoy.',
    offers: ['Quiet hours and sensory-aware layouts', 'Family experiences and celebrations', 'Visitor journey and queue strategy reviews'],
  },
];

export const sectorBySlug = (slug) => SECTORS.find((s) => s.slug === slug);
